import React from 'react'
import { Button, Spinner } from 'react-bootstrap'
import hooks from '../../../hooks'
import useAvailableRedemptions from '../available-ios-redemptions/use-available-redemptions'

const Center = ({ children }) => (<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>{children}</div>)

const IOSScreen = () => {
    const { endpoints } = hooks.useApi()
    const { windowLocation } = hooks.useClientLocation()

    const { availableRedemptions, isLoading } = useAvailableRedemptions()

    const onClick = React.useCallback(() => {
        console.log('endpoints.mobileIOSRedeem:', endpoints.mobileIOSRedeem)
        windowLocation(endpoints.mobileIOSRedeem, true)
    }, [windowLocation, endpoints])

    if (isLoading) {
        return (
            <Center>
                <Spinner animation="border" variant="primary" />
            </Center>
        )
    }

    if (!availableRedemptions) {
        return (
            <Center>
                This app isn't available at this time.  Please check back later.
            </Center>
        )
    }

    return (
        <Center>
            <Button
                onClick={onClick}
            >
                Click here to install iOS app
            </Button>

        </Center>
    )
}

export default IOSScreen
